import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Checkbox } from "rsuite";
import { Button } from "../../components/button.component";
import { SpinLoader } from "../../components/spinLoader.component";
import { ApiTaskSettings } from "../../core/apis/taskSettings";
import { StorageAuth } from "../../core/localStorage/StorageAuth";

export function TaskSettings({ expanded }: { expanded?: boolean }) {
  const { companyId: companyIdParam } = useParams<{ companyId: string }>();
  const [photoRequirement, setPhotoRequirement] = useState(false);
  const [signatureRequirement, setSignatureRequirement] = useState(false);
  const [videoRequirement, setVideoRequirement] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const CompanyId = companyIdParam ?? StorageAuth.CompanyId;

  const { data, isValidating } = ApiTaskSettings.ById.Hook(CompanyId || "");

  useEffect(() => {
    setPhotoRequirement(!!data?.photoRequirement);
    setSignatureRequirement(!!data?.signatureRequirement);
    setVideoRequirement(!!data?.videoRequirement);
  }, [data]);

  const handleSubmit = async () => {
    setIsLoading(true);
    const settingsData = {
      photoRequirement,
      signatureRequirement,
      videoRequirement,
      companySKey: CompanyId,
    };

    if (!data) await ApiTaskSettings.AddTaskSettings(settingsData);
    else
      await ApiTaskSettings.UpdateTaskSettings({
        ...settingsData,
        sKey: data.sKey,
      });
    setIsLoading(false);
  };

  return (
    <div className="accordion-item m-3 border-0">
      <p className="accordion-header" id="headingTwo">
        <button
          className="accordion-button p-3 px-4 rounded-pill shadow-none setting-header border border-green-200"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseTwo"
          aria-expanded={expanded}
          aria-controls="collapseTwo"
        >
          Task Settings&nbsp;{" "}
          {!!StorageAuth.CompanyName && (
            <small className="small-text">
              (Task settings for <b>{StorageAuth.CompanyName}</b>)
            </small>
          )}
        </button>
      </p>
      <div
        id="collapseTwo"
        className={`accordion-collapse collapse ${expanded ? "show" : "hide"}`}
        aria-labelledby="headingTwo"
        data-bs-parent="#accordionExample"
      >
        <div className="accordion-body border-bottom border-start border-end border-1 rounded setting-box">
          {isValidating ? (
            <div className="mb-5 pb-5">
              <SpinLoader />
            </div>
          ) : (
            <div>
              <div className="p-3 border-bottom d-flex flex-column">
                <Checkbox
                  checked={photoRequirement}
                  onChange={(_, checked) => setPhotoRequirement(checked)}
                >
                  Photo requirement
                </Checkbox>
                <Checkbox
                  checked={signatureRequirement}
                  onChange={(_, checked) => setSignatureRequirement(checked)}
                >
                  Signature requirement
                </Checkbox>
                <Checkbox
                  checked={videoRequirement}
                  onChange={(_, checked) => setVideoRequirement(checked)}
                >
                  Video requirement
                </Checkbox>
              </div>
              <div className="d-flex justify-content-center">
                <Button
                  onClick={() => handleSubmit()}
                  loading={isLoading}
                  disabled={isValidating}
                  className="px-5 mt-3 btn-green"
                  name="Update"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
